import styled from "styled-components";
import { useTranslation } from "react-i18next";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { filterSelectableDimensions, isCheckboxGroup, isGroup } from "../../Models/SelectableDimensions/SelectableDimensions";
import Box from "../../Styled/Box";
import Text from "../../Styled/Text";
import Collapsible from "../Custom/Collapsible/Collapsible";
import SelectableDimension from "./SelectableDimension";

/**
 * Component to render a SelectableDimensionGroup or DimensionSelectorCheckboxGroup.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SelectableDimensionGroup = _ref => {
  var _ref2, _dim$name, _dim$options$find$nam, _dim$options;
  let {
    id,
    dim
  } = _ref;
  const {
    t
  } = useTranslation();
  const childDims = filterSelectableDimensions(dim.placement)(dim.selectableDimensions);
  // Hide static groups with empty children.
  // We still show checkbox groups with empty children as they are stateful.
  if (isGroup(dim) && childDims.length === 0) return null;
  return /*#__PURE__*/_jsx(GroupContainer, {
    children: /*#__PURE__*/_jsx(Collapsible, {
      title: dim.type === "group" ? (_ref2 = (_dim$name = dim.name) !== null && _dim$name !== void 0 ? _dim$name : dim.id) !== null && _ref2 !== void 0 ? _ref2 : "" : (_dim$options$find$nam = (_dim$options = dim.options) === null || _dim$options === void 0 || (_dim$options = _dim$options.find(opt => opt.id === dim.selectedId)) === null || _dim$options === void 0 ? void 0 : _dim$options.name) !== null && _dim$options$find$nam !== void 0 ? _dim$options$find$nam : dim.selectedId === "true" ? t("selectableDimensions.enabled") : t("selectableDimensions.disabled"),
      titleTextProps: {
        bold: false
      },
      bodyBoxProps: {
        displayInlineBlock: true,
        fullWidth: true
      },
      bodyTextProps: {
        large: true
      },
      isOpen: dim.type === "group" ? dim.isOpen : dim.selectedId === "true",
      onToggle: dim.type === "group" ? dim.onToggle : isOpen => {
        dim.setDimensionValue(CommonStrata.user, isOpen ? "true" : "false");
        return false;
      },
      btnStyle: dim.type === "checkbox-group" ? "checkbox" : undefined,
      btnRight: dim.type === "group",
      children: /*#__PURE__*/_jsxs(Box, {
        displayInlineBlock: true,
        fullWidth: true,
        styledPadding: "5px 0 0 20px",
        children: [isCheckboxGroup(dim) && childDims.length === 0 && dim.emptyText && /*#__PURE__*/_jsx(Text, {
          children: dim.emptyText
        }), childDims.map(nestedDim => /*#__PURE__*/_jsx(SelectableDimension, {
          id: "".concat(id, "-").concat(nestedDim.id),
          dim: nestedDim
        }, "".concat(id, "-").concat(nestedDim.id)))]
      })
    })
  });
};
const GroupContainer = styled.div.withConfig({
  displayName: "Group__GroupContainer",
  componentId: "sc-17lmjs7-0"
})(["padding:10px 12px;border-radius:6px;background:", ";"], p => p.theme.overlay);